const animBorderRadiant = {

    init() {

        function isInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                // rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        var loaderWrappers = document.querySelectorAll('.lottie-wrapper');
        var isPlayed = [];
        
        window.addEventListener('load', () => {

            loaderWrappers.forEach((loaderWrapper, index) => {
                isPlayed.push(false);
                
                var bordersLottie = loaderWrapper.querySelectorAll('.border-lottie');

                if(isInViewport(loaderWrapper)) {

                    // if(isPlayed[index] == false) {
                        isPlayed[index] = true
                        bordersLottie.forEach(e => {
                            e.play()
                            e.setDirection(1)
                            e.setSpeed(0.5)
                        });
                    // }
                }
            });
        })

        document.addEventListener('scroll', function () {

            loaderWrappers.forEach((loaderWrapper, index) => {
                var bordersLottie = loaderWrapper.querySelectorAll('.border-lottie');

                if(isInViewport(loaderWrapper)) {
                    isPlayed[index] = false
                    bordersLottie.forEach(e => {
                        e.play()
                        e.setDirection(1)
                        e.setSpeed(0.5)
                    });
                }
                else {
                    isPlayed[index] = true
                    bordersLottie.forEach(e => {
                        e.play()
                        e.setDirection(-1)
                        e.setSpeed(2)
                    });
                }
            });
        });
    }
}

export default animBorderRadiant;